import type { Dictionary } from '../../i18n/dictionary';
import { plural } from '../../i18n/plural';

const pl = {
  appName: 'Brain',
  notes: 'Notatki',

  askTitle: 'Brain — ITLamb',
  askEmpty: 'Zapytaj o cokolwiek, co zapisałeś',
  recentQuestions: 'Ostatnie pytania',
  thinking: 'Myślę…',
  questionLabel: 'Pytanie',
  questionPlaceholder: 'Zapytaj o cokolwiek…',
  ask: 'Zapytaj',
  noAnswer: 'Nie mam notatki na ten temat.',
  fromNotes: (n: number) =>
    `Na podstawie ${String(n)} ${plural(n, 'notatki', 'notatek', 'notatek')}`,

  notesTitle: 'Notatki — Brain — ITLamb',
  note: 'Notatka',
  saved: 'Zapisano',
  noNotes: 'Nic jeszcze nie zapamiętano.',
  rememberSomething: 'Zapamiętaj coś',
  notePlaceholder: 'Jan mieszka przy ul. Dębowej 12 w Krakowie',
  saving: 'Zapisywanie…',
  remember: 'Zapamiętaj',
  editNote: 'Edytuj notatkę',
  save: 'Zapisz',
  cancel: 'Anuluj',
  deleteNote: 'Usuń tę notatkę',
  confirmForget: (preview: string) => `Zapomnieć „${preview}”?`,

  loadNotesFailed: 'Nie udało się wczytać notatek.',
  createNoteFailed: 'Nie udało się zapisać tej notatki.',
  updateNoteFailed: 'Nie udało się zapisać notatki.',
  noteSaved: 'Notatka zapisana.',
  deleteNoteFailed: 'Nie udało się usunąć notatki.',
  askFailed: 'Nie udało się odpowiedzieć na to pytanie.',
};

const en: typeof pl = {
  appName: 'Brain',
  notes: 'Notes',

  askTitle: 'Brain — ITLamb',
  askEmpty: 'Ask anything you have stored',
  recentQuestions: 'Recent questions',
  thinking: 'Thinking…',
  questionLabel: 'A question',
  questionPlaceholder: 'Ask anything…',
  ask: 'Ask',
  noAnswer: "I don't have a note about that.",
  fromNotes: (n) => `From ${String(n)} ${plural(n, 'note', 'notes', 'notes')}`,

  notesTitle: 'Notes — Brain — ITLamb',
  note: 'Note',
  saved: 'Saved',
  noNotes: 'Nothing remembered yet.',
  rememberSomething: 'Remember something',
  notePlaceholder: "John's address is 12 Oak Street, Leeds",
  saving: 'Saving…',
  remember: 'Remember',
  editNote: 'Edit note',
  save: 'Save',
  cancel: 'Cancel',
  deleteNote: 'Delete this note',
  confirmForget: (preview) => `Forget "${preview}"?`,

  loadNotesFailed: 'Could not load notes.',
  createNoteFailed: 'Could not save that note.',
  updateNoteFailed: 'Could not save the note.',
  noteSaved: 'Note saved.',
  deleteNoteFailed: 'Could not delete the note.',
  askFailed: 'Could not answer that.',
};

export const brainDict: Dictionary<typeof pl> = { pl, en };
